<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="card">
            <div class="card-title w-100 m-0">
                <div class="p-2" [ngClass.xl]="'d-flex justify-content-between'" [ngClass.md]="'d-flex justify-content-between'">
                    <div class="p-0" [ngClass.sm]="'col-12'">
                        <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off"
                               [(ngModel)]="searchKey" (ngModelChange)="searchField()"/>
                    </div>
                    <div [ngClass.sm]="'col-12 text-right mt-1 pr-0'">
                        <a class="btn btn-outline-primary text-primary" (click)="modalOpen(addNewField, null)"
                           *ngIf="_authenticationService.hasCapability('add_fieldDatabase')">{{'ADD' | translate}}</a>
                    </div>
                </div>
            </div>
            <div class="card-body p-0" *ngIf="_utilService.isDesktop">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="60"
                               [footerHeight]="50" [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}" [limit]="10"
                               [rows]="filteredFields">
                    <ngx-datatable-column [name]="'FIELD'|translate" prop="field">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div>
                                {{row.field}}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="'LABEL'|translate" prop="label">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div>
                                {{row.label}}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="'LANGUAGE'|translate" prop="language">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="text-capitalize">
                                {{row.language}}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="'ACTIONS'|translate" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="d-flex">
                                <button class="bg-transparent border-0 text-secondary pr-1"
                                        *ngIf="_authenticationService.hasCapability('edit_fieldDatabase')">
                                    <a (click)="modalOpen(editField, row)" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate"
                                       placement="left">
                                        <i [data-feather]="'edit-2'" size="19"></i>
                                    </a>
                                </button>
                                <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)"
                                        [ngbTooltip]="'DELETE' | translate" placement="left"
                                        *ngIf="_authenticationService.hasCapability('delete_fieldDatabase')">
                                    <i [data-feather]="'trash-2'" size="19"></i>
                                </button>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <div class="card-body p-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="150"
                               [footerHeight]="50" [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}" [limit]="10"
                               [rows]="filteredFields">
                    <ngx-datatable-column [name]="'FIELD'|translate" prop="field">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile">
                                <div class="col-12 p-0">
                                    {{row.field}}
                                </div>
                                <div class="col-12 p-0 text-truncate">
                                    <span class="font-weight-bold">{{ 'LABEL' | translate }}: </span>
                                    {{row.label}}
                                </div>
                                <div class="col-12 p-0">
                                    <span class="font-weight-bold">{{ 'LANGUAGE' | translate }}: </span>
                                    {{row.language}}
                                </div>
                                <div class="col-12 d-flex pl-0 justify-content-end" [ngClass.md]="'pr-2'">
                                    <button class="bg-transparent border-0 text-secondary pr-1"
                                            *ngIf="_authenticationService.hasCapability('edit_fieldDatabase')">
                                        <a (click)="modalOpen(editField, row)" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate"
                                           placement="left">
                                            <i [data-feather]="'edit-2'" size="19"></i>
                                        </a>
                                    </button>
                                    <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)"
                                            [ngbTooltip]="'DELETE' | translate" placement="left"
                                            *ngIf="_authenticationService.hasCapability('delete_fieldDatabase')">
                                        <i [data-feather]="'trash-2'" size="19"></i>
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </div>
</div>


<!-- Modal ADD -->
<ng-template #addNewField let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.close()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <h3>{{"MODAL.INSERT_FIELD" | translate}}</h3>
        <!--campo-->
        <div class="form-group">
            <label for="addField">{{"RECORD" | translate}}<sup class="text-danger">*</sup></label>
            <input type="text" class="form-control" name="addField" id="addField" [(ngModel)]="newField"/>
            <div class="font-error" *ngIf="showErrors && (!newField || newField.length < 1)">{{ 'ERRORS.INSERT_RECORD' | translate }}</div>
        </div>
        <!--label-->
        <div class="form-group">
            <label for="addLabel">{{"LABEL" | translate}}<sup class="text-danger">*</sup></label>
            <input type="text" class="form-control" name="addLabel" id="addLabel" [(ngModel)]="newLabel"/>
            <div class="font-error" *ngIf="showErrors && (!newLabel || newLabel.length < 1)">{{ 'ERRORS.INSERT_LABEL' | translate }}</div>
        </div>
        <!--lingua-->
        <div class="form-group">
            <label for="addLanguage">{{"LANGUAGE" | translate}}<sup class="text-danger">*</sup></label>
            <ng-select id="addLanguage" [(ngModel)]="newLanguage" [ngModelOptions]="{standalone: true}" [searchable]="true"
                       [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                <ng-option *ngFor="let language of languages_list" [value]="language">{{language}}</ng-option>
            </ng-select>
            <div class="font-error" *ngIf="showErrors && (!newLanguage || newLanguage.length < 1)">{{ 'ERRORS.INSERT_LANGUAGE' | translate }}</div>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
            {{"CANCEL" | translate}}
        </button>
        <button (click)="add()" type="submit" class="btn btn-primary w-150" rippleEffect>
            {{'INSERT_BUTTON'|translate}}
        </button>
    </div>
</ng-template>

<!-- Modal EDIT -->
<ng-template #editField let-modal>
    <div class="modal-header">
        <div></div>
        <button type="button" class="close" (click)="modal.close()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0">
        <h3>{{"MODAL.EDIT_FIELD" | translate}}</h3>
        <!--campo-->
        <div class="form-group">
            <label for="editField">{{"RECORD" | translate}}<sup class="text-danger">*</sup></label>
            <input type="text" class="form-control" name="field" id="editField" [(ngModel)]="currentField.field"/>
            <div class="font-error" *ngIf="showErrors && (!currentField.field || currentField.field.length < 1)">{{ 'ERRORS.INSERT_RECORD' | translate }}</div>
        </div>
        <!--label-->
        <div class="form-group">
            <label for="editLabel">{{"LABEL" | translate}}<sup class="text-danger">*</sup></label>
            <input type="text" class="form-control" name="label" id="editLabel" [(ngModel)]="currentField.label"/>
            <div class="font-error" *ngIf="showErrors && (!currentField.label || currentField.label.length < 1)">{{ 'ERRORS.INSERT_LABEL' | translate }}</div>
        </div>
        <!--lingua-->
        <div class="form-group">
            <label for="editLanguage">{{"LANGUAGE" | translate}}<sup class="text-danger">*</sup></label>
            <ng-select id="editLanguage" [(ngModel)]="currentField.language" [ngModelOptions]="{standalone: true}" [searchable]="true"
                       [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                <ng-option *ngFor="let language of languages_list" [value]="language">{{language}}</ng-option>
            </ng-select>
            <div class="font-error" *ngIf="showErrors && (!currentField.language || currentField.language.length < 1)">{{ 'ERRORS.INSERT_LANGUAGE' | translate }}</div>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-outline-primary w-150"
                (click)="modal.close()" rippleEffect>
            {{"CANCEL" | translate}}
        </button>
        <button (click)="edit()" type="submit" class="btn btn-primary w-150" rippleEffect>
            {{"EDIT" | translate}}
        </button>
    </div>
</ng-template>




